(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider'];

    function stateConfig($stateProvider, $stickyStateProvider) {
        $stateProvider
            .state('invoice-purchase', {
                parent: 'app',
                url: '/invoice/purchase',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.purchase.title',
                    title: 'Purchase Invoices'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice/invoices.html',
                        controller: 'InvoiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-purchase.all', {
                parent: 'app',
                url: '/invoice/purchase/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.purchase.title',
                    title: 'Purchase Invoices'
                },
                views: {
                    'invoice-purchase-all@': {
                        templateUrl: 'app/entities/invoice/invoices.html',
                        controller: 'InvoiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-purchase.invoice-purchase-detail', {
                parent: 'app',
                url: '/invoice/purchase/{id}/detail',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN'],
                    pageTitle: 'ccsTrApp.invoice.detail.title'
                },
                views: {
                    'invoice-purchase-detail@': {
                        templateUrl: 'app/entities/invoice/invoice-detail.html',
                        controller: 'InvoiceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('lot');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'InvoiceDTO', function($stateParams, $state, InvoiceDTO) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return InvoiceDTO.get({id : paramId}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'invoice-purchase',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('invoice-purchase.new', {
                parent: 'app',
                url: '/invoice/purchase/new?shipmentId',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.purchase.create',
                    title: 'New'
                },
                views: {
                    'invoice-purchase-new@': {
                        controller: 'InvoiceDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/invoice/invoice-dialog.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            createdOn: null,
                            createdBy: null,
                            modifiedOn: null,
                            modifiedBy: null,
                            invNum: null,
                            invType: "PURCHASE",
                            currency: null,
                            label: null,
                            invDate: new Date(),
                            invDueDate: null,
                            estPayment: null,
                            status: "DRAFT",
                            wtPrecision: null,
                            invWtUnits: null,
                            invGrossKgs: null,
                            invNetKgs: null,
                            invTareKgs: null,
                            landedGrossKgs: null,
                            landedNetKgs: null,
                            landedTareKgs: null,
                            invGrossLbs: null,
                            invNetLbs: null,
                            invTareLbs: null,
                            landedGrossLbs: null,
                            landedNetLbs: null,
                            landedTareLbs: null,
                            invGrossMTs: null,
                            invNetMTs: null,
                            invTareMTs: null,
                            landedGrossMTs: null,
                            landedNetMTs: null,
                            landedTareMTs: null,
                            qtyBales: null,
                            totalValue: null,
                            editedTotalValue: 0,
                            editedTotalValueEur: 0,
                            ncontractValueEur: 0,
                            ncontractDate: null,
                            exchangeRate: 0,
                            balanceDue: null,
                            id: null,
                            selectedContract: null,
                            paymentBank: null,
                            pricePrecision: 3,
                            weightPrecision: 3,
                            valuePrecision: 3,
                            isProvisionalPrice: false
                        };
                    }
                }
            })
            .state('invoice-purchase.edit', {
                parent: 'app',
                url: '/invoice/purchase/{id}/edit',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.purchase.edit',
                    title: 'Edit'
                },
                views: {
                    'invoice-purchase-edit@': {
                        controller: 'InvoiceDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/invoice/invoice-dialog.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "PURCHASE"
                        };
                    },
                    entity: ['$stateParams', '$state', 'Invoice', function( $stateParams, $state, Invoice ) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return Invoice.get( { id: paramId } ).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-purchase.gpfs-create', {
                parent: 'app',
                url: '/invoice/gpfs/create',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'Create Integration File',
                    title: 'Create Integration File'
                },
                views: {
                    'invoice-create-gpfs@': {
                        controller: 'InvoicesGpfsController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/invoice/invoices-gpfs.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            action: "CREATE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('currencyType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-purchase.gpfs-revert', {
                parent: 'app',
                url: '/invoice/gpfs/revert',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'Revert Integration File',
                    title: 'Revert Integration File'
                },
                views: {
                    'invoice-revert-gpfs@': {
                        controller: 'InvoicesGpfsController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/invoice/invoices-gpfs.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            action: "REVERT"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('currencyType');
                        return $translate.refresh();
                    }]
                }
            }).state('invoice-purchase.categorized-invoice', {
                parent: 'app',
                url: '/invoice/categorized',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'Categorized Invoices',
                    title: 'Categorized Invoices'
                },
                views: {
                    'invoice-categorized@': {
                        controller: 'InvoicesCategorizedController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/invoice/invoice-categorized.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('currencyType');
                        return $translate.refresh();
                    }]
                }
            }).state('invoice-purchase.report', {
            parent: 'app',
            url: '/invoice/report',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                pageTitle: 'Invoice Report',
                title: 'Invoice Report'
            },
            views: {
                'invoice-report@': {
                    controller: 'InvoiceReportController',
                    controllerAs: 'vm',
                    templateUrl: 'app/entities/invoice/invoice-report.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('contract');
                    $translatePartialLoader.addPart('shipment');
                    $translatePartialLoader.addPart('lot');
                    $translatePartialLoader.addPart('fixation');
                    $translatePartialLoader.addPart('keyword');
                    $translatePartialLoader.addPart('comment');
                    $translatePartialLoader.addPart('invoiceStatus');
                    $translatePartialLoader.addPart('wtUnitType');
                    $translatePartialLoader.addPart('currencyType');
                    return $translate.refresh();
                }]
            }
        });

        $stickyStateProvider.enableDebug(true);
    }
})();
